<template>
  <div class="w-full max-w-4xl mx-auto p-6 sm:p-8 pb-20">
    <h2 class="text-2xl font-bold mb-6 text-center">
      Reservation List ({{ side }})
    </h2>

    <div v-if="paginatedReservations.length" class="space-y-4">
      <div
        v-for="(reservation, index) in paginatedReservations"
        :key="reservation.id || index"
        class="flex items-start gap-4 p-4 border border-gray-200 rounded-xl shadow-sm bg-white"
      >
        <!-- Avatar -->
        <div
          class="w-12 h-12 flex-shrink-0 bg-gray-100 rounded-full flex items-center justify-center"
        >
          <font-awesome-icon
            :icon="['fas', 'user']"
            class="text-gray-500 text-xl"
          />
        </div>

        <!-- Content -->
        <div class="flex-grow">
          <div class="flex items-center gap-x-2">
            <p class="font-semibold text-base sm:text-lg text-gray-800">
              {{ reservation.name }}
            </p>
            <font-awesome-icon
              :icon="store.getStatusIcon(reservation.status)"
              :class="{
                'text-green-500': reservation.status === 'hadir',
                'text-red-500': reservation.status === 'tidak_hadir',
                'text-orange-500': reservation.status === 'ragu',
              }"
              class="text-xl sm:text-2xl"
            />
          </div>

          <!-- Message -->
          <p
            class="text-gray-600 mt-2 text-sm sm:text-base leading-snug text-justify whitespace-pre-line"
          >
            {{ reservation.message }}
          </p>
        </div>
      </div>
    </div>

    <p v-else class="text-center text-gray-500">No reservations yet.</p>

    <!-- Pagination -->
    <div v-if="totalPages > 1" class="flex justify-center mt-6 space-x-2">
      <button
        class="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300"
        :disabled="currentPage === 1"
        @click="currentPage--"
      >
        Prev
      </button>

      <button
        v-for="page in totalPages"
        :key="page"
        @click="currentPage = page"
        :class="[
          'px-3 py-1 rounded',
          currentPage === page
            ? 'bg-blue-600 text-white'
            : 'bg-gray-100 hover:bg-gray-200',
        ]"
      >
        {{ page }}
      </button>

      <button
        class="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300"
        :disabled="currentPage === totalPages"
        @click="currentPage++"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useReservationStore } from "@/stores/reservationStore";

const route = useRoute();
const side = route.params.side as string;
const store = useReservationStore();

const currentPage = ref(1);
const pageSize = 5;

const totalPages = computed(() => {
  return Math.ceil(store.reservations.length / pageSize);
});

const paginatedReservations = computed(() => {
  const start = (currentPage.value - 1) * pageSize;
  return store.reservations.slice(start, start + pageSize);
});

onMounted(() => {
  store.fetchReservations(side);
});

watch(
  () => route.params.side,
  (newSide) => {
    store.fetchReservations(newSide as string);
    currentPage.value = 1; // reset ke halaman 1 saat ganti side
  }
);
</script>
